import styled from "styled-components";
import type { FC } from "react";
import { Button } from "@similarweb/ui-components";
import { translate } from "app/filters/i18nFilter";
import { useOnEnter } from "app/custom-hooks/useOnKeyUp";

interface SaveProps {
    onSave: VoidFunction;
    isDisabled: boolean;
    isLoading: boolean;
}
interface FooterProps {
    onCancel: VoidFunction;
    saveProps: SaveProps;
}

const FooterContainer = styled.div`
    display: flex;
    justify-content: space-between;
`;

export const Footer: FC<FooterProps> = (props) => {
    const { onCancel, saveProps } = props;
    const { onSave, isDisabled, isLoading } = saveProps;
    useOnEnter(onSave);
    return (
        <FooterContainer>
            <Button
                type="flat"
                onClick={onCancel}
            >
                {translate("segments.popup.wizard.footer.cancel")}
            </Button>
            <Button
                type="primary"
                isDisabled={isDisabled}
                onClick={onSave}
                isLoading={isLoading}
            >
                {translate("segments.popup.wizard.footer.save")}
            </Button>
        </FooterContainer>
    );
};
